import { useEffect, useRef, useState } from 'react';
import type { Socket } from 'socket.io-client';
import {
  ConnectionQualityHelper,
  INITIAL_CONNECTION_QUALITY_STATE
} from './connectionQuality/ConnectionQualityHelper';
import { getConnectionQualityMockState } from './connectionQuality/ConnectionQualityMockHelper';
import type { ConnectionQualityState } from '../types/connectionQuality';

export function useConnectionQuality(socket: Socket | null): ConnectionQualityState {
  const mockState = getConnectionQualityMockState();
  const [state, setState] = useState<ConnectionQualityState>(INITIAL_CONNECTION_QUALITY_STATE);
  const helperRef = useRef(new ConnectionQualityHelper());

  useEffect(() => {
    if (mockState) {
      return;
    }

    if (!socket) {
      setState(INITIAL_CONNECTION_QUALITY_STATE);
      return;
    }

    const helper = helperRef.current;
    helper.bind(socket, setState);

    return () => {
      helper.dispose(socket);
    };
  }, [mockState, socket]);

  if (mockState) {
    return mockState;
  }

  return state;
}
